export const IS_LOADING = "IS_LOADING";

export const STARTUP_DATA_SUCCESS = "STARTUP_DATA_SUCCESS";
export const GAMBLING_CONTROL_SUCCESS = "GAMBLING_CONTROL_SUCCESS";
export const CMS_STATIC_CONTENT_SUCCESS = "CMS_STATIC_CONTENT_SUCCESS";

export const SET_ERROR = "SET_ERROR";
